module.exports = __webpack_public_path__ + "static/media/Hurtigbenevning-instruction.5e81f9e5.mp3";